import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { deleteKeys } from "lib/transforms"
import { CustomerDetail, CustomerDetailTabEnum } from "modules/customers/components/Detail"
import { CustomerSearchSchema } from "schema"

export const Route = createFileRoute("/_base/_auth/campaigns/$id/activity/$customerId")({
  component: RouteComponent,
  validateSearch: CustomerSearchSchema,
})

function RouteComponent() {
  const { customerId } = Route.useParams()
  const search = Route.useSearch()
  const params = Route.useParams()
  const navigate = useNavigate()

  function onClose() {
    navigate({ to: "/campaigns/$id/activity", params, search })
  }

  function onTabChange(tab: CustomerDetailTabEnum) {
    navigate({
      to: Route.fullPath,
      params,
      search: { ...search, tab },
    })
  }

  function onConversationClick(conversationId?: string) {
    navigate({
      to: Route.fullPath,
      params,
      search:
        conversationId === undefined
          ? { ...deleteKeys(["conversationId"], search), tab: "conversations" }
          : { ...search, tab: "conversations", conversationId },
    })
  }

  function onArchivedCustomerRedirect(originalCustomerId: string) {
    navigate({
      to: Route.fullPath,
      params: { ...params, customerId: originalCustomerId },
      search,
      replace: true,
    })
  }

  return (
    <CustomerDetail
      customerId={customerId}
      conversationId={search.conversationId?.toString()}
      campaignId={params.id}
      onClose={onClose}
      currentTab={search.tab}
      onTabChange={onTabChange}
      onConversationClick={onConversationClick}
      issueId={search.issueId}
      onIssueClick={(issueId, tab) => {
        navigate({
          to: Route.fullPath,
          params,
          search: { ...search, tab, issueId },
        })
      }}
      onArchivedCustomerRedirect={onArchivedCustomerRedirect}
    />
  )
}
